module Client.Components.ServiceCallInfo

open Client
open Shared
open global.Elmish
open Fable.Core.JsInterop
open Feliz
open Feliz.MaterialUI
open Thoth.Fetch
open Fable.Core.JS
open Feliz.SweetAlert
open Feliz.UseElmish
open Fetch

type Model =
  | InitialState
  | RequestingEta
  | EtaRequested

type Msg =
  | RequestEta of (string * Shared.ServiceCallEtaRequest)
  | RequestEtaResult of Result<string,string>

let requestEta (token, request : Shared.ServiceCallEtaRequest) : Promise<string> =
  promise {
    let decoder = Services.decoder<string>
    let authHeader = HttpRequestHeaders.Authorization <| sprintf "Bearer %s" token
    return! Fetch.post<_,string>("/api/Service/RequestEta", request, decoder = decoder,headers = [authHeader])
  }

let requestEtaCmd request =
  Cmd.OfPromise.either requestEta request
    (Ok >> RequestEtaResult)
    (fun x -> Error "Unable to process request. Please retry." |> RequestEtaResult)

let init () =
  InitialState, Cmd.none

let update msg (model : Model) =
  match msg with
  | RequestEta r ->
    RequestingEta, requestEtaCmd r
  | RequestEtaResult r ->
    match r with
    | Ok v -> EtaRequested, Cmd.Swal.Simple.info "Thank you. Your service ETA request has been received, and you will receive a notification when your request has been processed."
    | Error msg -> InitialState, Cmd.Swal.Simple.warning msg


let viewCall = React.functionComponent (fun (inputProps: {| token : string; i : int; equipmentNumber : string; call : Shared.ServiceCall; customerContactName : string option; customerContactEmail : string; |}) ->
  let state, dispatch = React.useElmish(init(),update, [||])
  let classes = Styles.useStyles()
  let buttonProgressIndicator =
    Mui.circularProgress [
      prop.className classes.buttonProgress
      prop.size 24
    ]
  Mui.listItem [
    listItem.alignItems.flexStart
    listItem.children [
      Mui.listItemText [
        listItemText.primary inputProps.call.Number
        listItemText.secondary [
          Mui.typography [
            typography.display.inline'
            typography.children "Status: "
          ]
          Mui.typography [
            typography.display.inline'
            typography.variant.body2
            typography.children inputProps.call.Status
          ]
          Html.br []
          Mui.typography [
            typography.display.inline'
            typography.children "Received: "
          ]
          Mui.typography [
            typography.display.inline'
            typography.variant.body2
            typography.children (inputProps.call.ReceivedDate.ToString("MM/dd/yyyy"))
          ]
          Html.br []
          Mui.typography [
            typography.display.inline'
            typography.children (sprintf "Description: ")
          ]
          Mui.typography [
            typography.display.inline'
            typography.variant.body2
            typography.children inputProps.call.Description
          ]
        ]
      ]
      Mui.listItemSecondaryAction [
        prop.style [
          style.top (Feliz.length.percent 0)
          style.marginTop (Feliz.length.px 25)
        ]
        prop.children [
        // listItemSecondaryAction.children [

          Html.div [
            prop.className classes.wrapper
            prop.children [
              let buttonLabelText =
                match state with
                | EtaRequested -> "ETA Requested"
                | RequestingEta
                | InitialState -> "Request ETA"
              Mui.button [
                button.children buttonLabelText
                button.variant.contained
                button.disabled (state = EtaRequested || state = RequestingEta)
                button.color.default'
                prop.onClick (fun e ->
                  e.preventDefault ()
                  let request =
                    { ServiceCallEtaRequest.CallId = inputProps.call.Id
                      CallNumber = inputProps.call.Number
                      EquipmentNumber = inputProps.equipmentNumber
                      CustomerContactName = inputProps.customerContactName
                      CustomerContactEmail = inputProps.customerContactEmail }
                  RequestEta (inputProps.token,request) |> dispatch
                )
              ]
              if state = RequestingEta then buttonProgressIndicator else Html.none
            ]
          ]
        ]
      ]
    ]
  ]

)

let view = React.functionComponent (fun (inputProps: {| token : string; equipmentNumber : string; calls : Shared.ServiceCall list; customerContactName : string option; customerContactEmail : string; |}) ->

  Mui.list [
    prop.width 100
    list.children [
      yield! inputProps.calls
      |> List.mapi (fun i call ->
        [
            viewCall {| token = inputProps.token; equipmentNumber = inputProps.equipmentNumber; call = call; i = i; customerContactName = inputProps.customerContactName; customerContactEmail = inputProps.customerContactEmail; |}
            if inputProps.calls.Length > 1 && (i+1) < inputProps.calls.Length then
              Mui.divider []
        ]
      )
      |> List.concat
    ]
  ]
)